import React from "react";
import { BsBehance, BsGithub, BsLinkedin } from "react-icons/all";
import { Divider } from "antd";
import logo from "../assets/img/logo.svg";

const Links = () => {
  return (
    <section id="links">
      <div className="d-flex justify-content-evenly">
        <a
          href="https://github.com/makindiilete"
          target="_blank"
          rel="noreferrer"
        >
          <p className="fw-bold">
            <BsGithub /> GitHub
          </p>
        </a>
        <a
          href="https://www.linkedin.com/in/michael-akindiilete-b8927516b/"
          target="_blank"
          rel="noreferrer"
        >
          <p className="fw-bold">
            {" "}
            <BsLinkedin /> LinkedIn
          </p>
        </a>
        <a
          href="https://www.behance.net/michaelakindii"
          target="_blank"
          rel="noreferrer"
        >
          <p className="fw-bold">
            {" "}
            <BsBehance /> Behance
          </p>
        </a>
      </div>
      <Divider className="bg-light" />
    </section>
  );
};

export default Links;
